import React, { Component } from "react";
import { formatAmount } from "../utils/Utils";

export default class CarInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: 0,
    };
  }
  componentDidMount() {
    this.setAmount();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setAmount();
    }
  }
  openModalLiising() {
    this.props.openModalLiising();
  }

  setAmount = () => {
    const { data } = this.props;
    var amount = "";
    /*
    
    Hinnaklass 115 000€ / 260kw   al. 1300 € aasta / al. 108,33 € kuu

Hinnaklass 125 000€ / 346 kw  al. 1450 € aasta / al. 120,83 € kuu

Hinnaklass 130 000€ / 346 kw  al. 1450 € aasta / al. 120,83 € kuu

Hinnaklass 140 000€ / 382 kw.  al. 1600 € aasta / al. 133,33 € kuu
*/

    if ( data.eripakkumine === "115000.00") {
      this.setState({ amount: 108 });
      amount = 1300;
    } else if ( data.eripakkumine === "125000.00") {
      this.setState({ amount: 120 });
      amount = 1450;
    } else if ( data.eripakkumine === "130000.00") {
      this.setState({ amount: 120 });
      amount = 1450;
    } else if (data.eripakkumine === "140000.00") {
      amount = 1600;
      this.setState({ amount: 133 });
    } else {
      this.setState({ amount: 100 });
    }
  };

  render() {
    const { data } = this.props;

    return (
      <>
        <div className="specs">
          <h1>Porsche {data.trim} </h1>
          <span>
            {data.mootor} {data.power_kw}kW {data.transmission}
          </span>
          <span> Kom. Nr. {data.komnr} </span>
          <span className="specs-price">Auto hind: {formatAmount(data.eripakkumine)} €</span>
   {data.reserved === "jah" || data.reserved === "Jah" ? (
            <span className="reserved">BRONEERITUD</span>
          ) : (
            ""
          )}
          <span>
            Liisingu kuumakse alates: {formatAmount(data.manualkuumakse)} €
          </span>
       
          <span>
            Kasko kuumakse alates: {data.manual_kasko_kuumakse ? data.manual_kasko_kuumakse : formatAmount(Math.floor(this.state.amount))} €
          </span>
          <span
            className="text text--underline"
            onClick={() => this.openModalLiising(data.komnr)}
          >
            Liisingu- ja kaskokindlustuse tingimused
          </span>
        </div>
      </>
    );
  }
}
